import { useRouter } from "expo-router";
import { FlatList, StyleSheet } from "react-native";
import { HomeSection } from "../../src/components";
import { useAppSelector } from "../../src/hooks";

import { Property, isWeb } from "@stepapp/core";
import { Block, Divider, IconButton, ProfileInfo, Typography, palette, spacing } from "@stepapp/ui";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

const keyExtractor = ({ propertyId }: Property) => propertyId;

const ProfileScreen = () => {
  const { t } = useTranslation();
  const { navigate } = useRouter();
  const { firstName, lastName, profile, properties } = useAppSelector(({ user }) => user);

  const ListHeaderComponent = useCallback(
    () => (
      <>
        <Block alignCenter justifySpace row marginTop={isWeb ? 3.5 : 1.5}>
          <Typography variant="newH2">{t("screens.profile.title")}</Typography>

          <IconButton
            size={spacing.unit * 4.5}
            name="edit"
            iconSize={spacing.unit * 2}
            onPress={() => navigate("/profile/edit")}
            style={styles.editButton}
            iconColor={palette.common.white}
          />
        </Block>

        <ProfileInfo avatar={profile?.avatar} firstName={firstName} lastName={lastName} t={t} />

        {!!profile?.description && (
          <Block paddingBottom={2} paddingTop={1}>
            <Typography>{profile.description}</Typography>
          </Block>
        )}

        <Divider color={palette.secondary.grey} />
      </>
    ),
    [profile, lastName, firstName, navigate, t],
  );

  const renderItem = useCallback(
    ({ item }: { item: Property }) => <HomeSection key={item.propertyId} property={item} />,
    [],
  );

  return (
    <FlatList
      ListHeaderComponent={ListHeaderComponent}
      contentContainerStyle={styles.container}
      data={properties}
      keyExtractor={keyExtractor}
      renderItem={renderItem}
    />
  );
};

export default ProfileScreen;

const styles = StyleSheet.create({
  container: {
    paddingBottom: spacing.unit * 5,
  },
  editButton: {
    backgroundColor: palette.primary.accent,
  },
});
